<template>
  <div class="row" v-if="policy.settings && policy.product === 'OGPO_WEB_EA' && policy.product_type !== 7">
    <div class="col-lg-3 col-md-6" v-if="false && policy.settings.rewrite && (!supportInfo || supportInfo.status !== 10)">
      <div
          class="btn btn-bg-light btn-icon-primary text-primary btn-sm btn-block me-2 mb-2 cursor-pointer"
          @click="toOgpo(1)"
      >
        <i class="ki-duotone ki-update-folder fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Переоформление
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="false && policy.settings.prolongation && (!supportInfo || supportInfo.status !== 10)">
      <div
          class="btn btn-bg-light btn-icon-primary text-primary btn-sm btn-block me-2 mb-2 cursor-pointer"
          @click="toOgpo(0)"
      >
        <i class="ki-duotone ki-folder-up fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Пролонгация
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="policy.settings.error && (!supportInfo || supportInfo.status !== 10)">
      <div
          @click="rescind(policy)"
          class="btn btn-bg-light btn-icon-primary text-primary btn-sm btn-block me-2 mb-2 cursor-pointer"
      >
        <i class="ki-duotone ki-minus-folder fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Ошибка оператора
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="false && policy.settings.termination && (!supportInfo || supportInfo.status !== 10)">
      <div
          @click="dissolution(policy)"
          class="btn btn-bg-light btn-icon-primary text-primary btn-sm btn-block me-2 mb-2 cursor-pointer"
      >
        <i class="ki-duotone ki-delete-folder fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Расторжение
      </div>
    </div>
    <div class="col-lg-3 col-md-6" v-if="supportInfo && (!supportInfo || supportInfo.status !== 10)">
      <div
          @click="rejectSupport(supportInfo)"
          class="btn btn-bg-light btn-icon-primary text-primary btn-sm btn-block me-2 mb-2 cursor-pointer"
      >
        <i class="ki-duotone ki-delete-folder fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        Отказ в поддержке
      </div>
    </div>
    <div class="col-12">
      <hr class="text-gray-400"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyActions',
  props: {
    policy: null,
    supportInfo: null
  },
  methods: {
    toOgpo(isRewrite) {
      this.$emit('toOgpo', isRewrite)
    },
    rescind(policy) {
      this.$emit('rescind', policy)
    },
    dissolution(policy) {
      this.$emit('rescind', policy)
    },
    rejectSupport(supportInfo) {
      this.$emit('rejectSupport', supportInfo)
    }
  }
}
</script>

<style scoped>

</style>